import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const ChartWidget: WidgetRegistryEntry = {
  name: "Chart",
  configuration: () => import("./configuration").then((m) => m.ChartWidgetConfiguration),
  component: () => import("./chart-widget.component").then((m) => m.ChartWidgetComponent)
};
